export default {
  ROLE_ADMIN_NAME: 1,
  ROLE_TAXI_NAME: 2,
  ROLE_HOTEL_NAME: 3,
  ROLE_CS_NAME: 4,
}
